import React from 'react'
import Cookies from 'js-cookie'
import Modal from 'src/components/UI/Modal/Modal'
import PricesSpecial from 'src/components/Purchase/PricesSpecial/PricesSpecial'

const PricesSpecialModal = ({ foundSpecialPrice }) => (
    <Modal
        name="pricesSpecial"
        handleClose={() => {
            Cookies.set('pricesSpecialDismissed', foundSpecialPrice.period, { expires: 30 })
        }}
        nested>
        <PricesSpecial {...foundSpecialPrice} />
    </Modal>
)

export default PricesSpecialModal
